import { Info } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

export default function Steps({ overline, title, items, disclosure }) {
  return (
    <section className="bg-paper py-20 md:py-28 border-t border-line" data-testid="steps">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <Overline>{overline}</Overline>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight max-w-2xl leading-[1.08]">
            {title}
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {items.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="h-full rounded-2xl border border-line bg-mist p-8 relative overflow-hidden">
                <span className="font-serif font-semibold text-6xl text-brand/20 leading-none">{s.n}</span>
                <h3 className="mt-5 text-xl font-semibold tracking-tight">{s.t}</h3>
                <p className="mt-2 text-stone leading-relaxed text-sm">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {disclosure && (
          <Reveal className="mt-6 flex items-start gap-2 text-sm text-stone max-w-2xl">
            <Info size={16} className="mt-0.5 shrink-0 text-brand" />
            <span>{disclosure}</span>
          </Reveal>
        )}
      </div>
    </section>
  );
}
